class WIheader extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this._cacheElements();
        // transparante pagina's: scroll-gedrag. Alle andere: altijd solid (al via Liquid class).
        this.isTransparent = this.hasAttribute('data-transparent');
        // Product paginas zijn via Liquid niet transparent, maar extra zekerheid:
        if (window.pageType === 'product') {
            this.classList.add('WI_header_solid');
        }
        if (this.isTransparent) {
            this.handleScroll();
        }
    }

    _cacheElements() {
        this.addBar = this.querySelector('.WI_annBar_main');
    }

    handleScroll() {
        document.addEventListener('scroll', () => {
            const scrollY = window.scrollY;

            if (scrollY > 50) {
                this.classList.add('WI_header_solid');
            } else {
                this.classList.remove('WI_header_solid');
            }

            const collectionFilterTab = document.querySelector('.WI_mainCollection_filter');
            if (scrollY > 800) {
                collectionFilterTab?.classList.add('WI_mainCollection_filter_position');
                document.dispatchEvent(new CustomEvent('scroll:down', { bubbles: true }));
            } else {
                collectionFilterTab?.classList.remove('WI_mainCollection_filter_position');
            }
        }, { passive: true });
    }
}

customElements.define('wi-header', WIheader);
